import { Navigate, useNavigate, useParams } from 'react-router';
import { Save, Undo2 } from 'lucide';

//MUI
import Paper from '@mui/material/Paper';

//common
import { ROUTES_PATH } from 'layout/constants';
import Icon from 'common/components/Icon';
import MuiLoading from 'common/components/MuiLoading';
import SchemaForm from 'common/SchemaForm';
import OperationCodeField from 'common/components/OperationCodeField';

//screen
import useGetDepartmentDetail, {
  type DepartmentDetailInfo,
} from 'modules/department/services/useGetDepartmentDetail';

const DepartmentDetailPage = () => {
  const urlParams = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useGetDepartmentDetail({
    id: urlParams['id'] || '',
    orgType: urlParams['orgType'] || '',
  });

  const previousPage = ['', ROUTES_PATH.ad.index, ROUTES_PATH.department.index];

  if (isLoading) return <MuiLoading />;
  if (!data && urlParams.id) return <Navigate to={ROUTES_PATH[404]} replace />;

  return (
    <Paper className="p-2 tablet:p-4">
      <SchemaForm<DepartmentDetailInfo>
        formHookProps={{
          values: data || undefined,
          defaultValues: {
            status: true,
            name: '',
            description: '',
          },
        }}
        globalProps={{ readOnly: true }}
        schema={{
          fields: ({ formProps: { intl, readOnly } }) => {
            return {
              orgType: {
                mode: 'text-field',
                propsWrapper: { tablet: 6 },
                label: intl.formatMessage({ id: 'department.organizationType' }),
              },
              operationCode: {
                mode: 'raw',
                propsWrapper: { tablet: 6 },
                render: (params) => (
                  <OperationCodeField
                    {...params}
                    label={intl.formatMessage({ id: 'department.operationCode' })}
                    required={false}
                  />
                ),
              },
              name: {
                mode: 'text-field',
                propsWrapper: { tablet: 6 },
                label: intl.formatMessage({ id: 'department.unitName' }),
              },

              city: {
                mode: 'text-field',
                propsWrapper: { tablet: 6 },
                label: intl.formatMessage({ id: 'account.stateOrCity' }),
              },
              district: {
                mode: 'text-field',
                propsWrapper: { tablet: 6 },
                label: intl.formatMessage({ id: 'account.formerDistrictName' }),
              },
              description: {
                mode: 'text-field',
                label: intl.formatMessage({ id: 'description' }),
                placeholder: intl.formatMessage({ id: 'noDescriptionYet' }),
                multiline: true,
                rows: 3,
              },
              status: {
                mode: 'switch',
                propsWrapper: { tablet: 6 },
                label: intl.formatMessage({ id: 'statusAdmin' }),
                labelPlacement: 'top',
              },
              blank2: { mode: 'node' },
              back: {
                mode: 'button',
                variant: 'outlined',
                startIcon: <Icon icon={Undo2} size={16} />,
                children: intl.formatMessage({ id: 'back' }),
                onClick: () => navigate(previousPage.join('/')),
                propsWrapper: {
                  mobile: true,
                  display: 'flex',
                  justifyContent: 'flex-end',
                },
              },
              submit: {
                mode: 'button',
                type: 'submit',
                variant: 'contained',
                startIcon: <Icon icon={Save} size={16} />,
                hidden: readOnly,
                children: intl.formatMessage({ id: 'save' }),
                propsWrapper: { mobile: undefined },
              },
            };
          },
        }}
      />
    </Paper>
  );
};
export default DepartmentDetailPage;
